import { render, staticRenderFns } from "./Updateemp.vue?vue&type=template&id=ed4e6566&scoped=true"
import script from "./Updateemp.vue?vue&type=script&lang=js"
export * from "./Updateemp.vue?vue&type=script&lang=js"
import style0 from "./Updateemp.vue?vue&type=style&index=0&id=ed4e6566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4e6566",
  null
  
)

export default component.exports